import ArrowLineRoundRight from 'assets/Icons/Arrow/ArrowLineRoundRight';
import GenderMan from 'assets/Icons/Gender/GenderMan';
import GenderWoman from 'assets/Icons/Gender/GenderWoman';
import { ListWrapper, TableCell } from 'components/Hospital/PaginationForms';
import { pagePaths } from 'constants/path';
import { clUserLookupListWidth } from 'constants/pagination';
import moment from 'moment';
import { ICLUserInfo } from 'models/CL/CLBasicInterface';
import { useNavigate } from 'react-router-dom';
import { changeMobileForm } from 'utils/changeMobileForm';

interface CLUserLookupTableProps {
    data: ICLUserInfo[];
}

const formatGender = (gender?: string) => {
    if (gender === 'male') return '남성';
    if (gender === 'female') return '여성';
    return '미입력';
};

const CLUserLookupTable = ({ data }: CLUserLookupTableProps) => {
    const navigate = useNavigate();

    const handleRowClick = (item: ICLUserInfo) => {
        if (!item._id) return;
        navigate(`${pagePaths.CLAdminUserDetailBase}/${item._id}`, { state: item });
    };

    return (
        <>
            {data.map((item, idx) => {
                const userKey = item._id || item.uid || `${item.email}-${idx}`;
                return (
                    <ListWrapper key={userKey} onClick={() => handleRowClick(item)} $borderBottom='visible'>
                        <TableCell $width={clUserLookupListWidth[0]} $type='name'>
                            {item.name || '미입력'}
                            {item.gender === 'male' && <GenderMan />}
                            {item.gender === 'female' && <GenderWoman />}
                        </TableCell>
                        <TableCell $width={clUserLookupListWidth[1]}>{item.email || '미입력'}</TableCell>
                        <TableCell $width={clUserLookupListWidth[2]}>{item.mobile ? changeMobileForm(item.mobile) : '미입력'}</TableCell>
                        <TableCell $width={clUserLookupListWidth[3]}>{item.birthday ? moment(item.birthday, 'YYYYMMDD').format('YYYY/MM/DD') : '미입력'}</TableCell>
                        <TableCell $width={clUserLookupListWidth[4]}>{formatGender(item.gender)}</TableCell>
                        <TableCell $width={clUserLookupListWidth[5]}>{item.registrationTimestamp ? moment(item.registrationTimestamp).format('YYYY/MM/DD') : '미입력'}</TableCell>
                        <TableCell $width={clUserLookupListWidth[6]} $maxWidth='60px'>
                            <ArrowLineRoundRight />
                        </TableCell>
                    </ListWrapper>
                );
            })}
        </>
    );
};

export default CLUserLookupTable;
